<div class="d-flex justify-content-center">
  <div class="card p-5">
    <div class="card-header text-center">
      <h4 class="display-5">{{batchTitle}}</h4>
    </div>
    <div class="row mb-3 mt-3">
      <div class="col-md-6">
        <div class="fieldset fieldset--lg ">
          <label for="name" class="legend">Name: <span class="requiredfield">*</span></label>
          <input class="text-field" required type="text" id="name" name="name" [(ngModel)]="moduleBatch.name" autofocus [disabled]="!showSave">
        </div>
      </div>

      <div class="col-md-6">
        <div class="fieldset fieldset--lg">
          <label for="startt" class="legend">Start Date: <span class="requiredfield">*</span></label>
          <input [owlDateTime]="rawStartTime" class="text-field" id="startDate" name="startDate" [disabled]="!showSave"
            [(ngModel)]="moduleBatch.startDate">
          <button [owlDateTimeTrigger]="rawStartTime" type="button"
            class="owlDateTimeTrigger bottom-0 position-absolute right-0 top-0 m-auto d-flex align-items-center px-3 bg-transparent border-0 text-body"
            title="Calendar" [disabled]="!showSave"><i class="fa fa-calendar"></i></button>
          <owl-date-time #rawStartTime></owl-date-time>
        </div>
      </div>
    </div>

    <div class="row mb-3">
      <div class="col-md-6">
        <div class="fieldset fieldset--lg">
          <label for="endt" class="legend">End Date: <span class="requiredfield">*</span></label>
          <input [owlDateTime]="rawEndTime" class="text-field" id="inviteEndDate" name="inviteEndDate"
            [disabled]="!showSave" [(ngModel)]="moduleBatch.endDate">
          <button [owlDateTimeTrigger]="rawEndTime" type="button" [disabled]="!showSave"
            class="owlDateTimeTrigger position-absolute right-0 top-0 bottom-0 m-auto d-flex align-items-center px-3 bg-transparent border-0 text-body"
            title="Calendar"><i class="fa fa-calendar"></i></button>
          <owl-date-time #rawEndTime></owl-date-time>
        </div>
      </div>


    </div>
     <div class="d-flex justify-content-around mb-3" *ngIf="showSave">

        <button type="submit" class="btn btn-lg m-0" (click)="SaveBatch()">Save</button>
      </div>
    <div class="card-footer" *ngIf="asssmentDate.length>=0 && isEdit">
      <!-- Card header -->
      <div class="card-header border-0">
        <div class="d-flex justify-content-center">
          <h3 class="mb-0">Assessment</h3>
        </div>
      </div>
      <div class="table-responsive">
        <table class="table align-items-center table-flush table-hover">
          <!-- <thead>
                  <tr>
                      <th colspan="4" class="text-right"> Total : </th><th class="text-right">₦{{this.util.numberWithCommas(sumTotal)}}</th>
                  </tr>
              </thead> -->
          <thead class="thead-light">
            <tr>
              <th> Name </th>
              <th> Class Title </th>
              <!-- <th> Class Position </th> -->
              <th> Start DateTime</th>
              <th> Stop DateTime</th>
              <th class="mb-0 text-center" *ngIf="isAssessmentEditable"> Action</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of asssmentDate; let i= index" class="handCusor">
              <td>{{item.name}}</td>
              <td>{{item.classTitle}}</td>
              <!-- <td class="text-center">{{item.classPosition}}</td> -->
              <td>
                <div class="fieldset m-0">
                  <input [owlDateTime]="rawStartTime" class="text-field" id="startDate" name="startDate" [disabled]="!item.editable"
                    [(ngModel)]="item.startTime" autofocus>
                  <button [owlDateTimeTrigger]="rawStartTime" type="button"
                    class="owlDateTimeTrigger bottom-0 position-absolute right-0 top-0 m-auto d-flex align-items-center px-3 bg-transparent border-0 text-body"
                    title="Calendar" [disabled]="!item.editable"><i class="fa fa-calendar"></i></button>
                  <owl-date-time #rawStartTime></owl-date-time>
                </div>
              </td>
              <td>
                <div class="fieldset m-0">
                  <input [owlDateTime]="rawEndTime" class="text-field" id="startDate" name="startDate" [disabled]="!item.editable"
                    [(ngModel)]="item.stopTime" >
                  <button [owlDateTimeTrigger]="rawEndTime" type="button"
                    class="owlDateTimeTrigger bottom-0 position-absolute right-0 top-0 m-auto d-flex align-items-center px-3 bg-transparent border-0 text-body"
                    title="Calendar" [disabled]="!item.editable"><i class="fa fa-calendar"></i></button>
                  <owl-date-time #rawEndTime></owl-date-time>
                </div>
              </td>

              <td class="mb-0">
                <!-- <span><i class="fas fa-edit handCusor text-primary mr-3" (click)="editBatch(item)">Edit</i></span>
                <span><i class="fas fa-eye handCusor text-primary">View</i></span> -->
                <button class="btn btn-primary" *ngIf="!item.editable && isAssessmentEditable"
                (click)="onRowEditInit(item,i)">Edit</button>
                  <button class="btn btn-primary" *ngIf="item.editable && isAssessmentEditable"
                  (click)="submitAssessmentBatch(item)">Update</button>
              </td>
            </tr>
          </tbody>
        </table>
        <p *ngIf="asssmentDate.length<=0" class="text-center">No Available Assessments</p>
      </div>
    </div>
  </div>


  <!-- <div class="modal fade" id="updateAssessmentDate" data-keyboard="false" data-backdrop="static" aria-hidden="true"
    role="dialog">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body pt-0">
          <div class="text-uppercase">
            <h3 class="modal-title text-center mb-2">Assessment Date Update for {{assessmentDateUpdate.name}}</h3>
            <div class="row row-cols-2 mb-3">
              <div class="col">
                <label class="sbw_light">Start Time:</label>
                <input class="form-control" type="datetime-local" [(ngModel)]="assessmentDateUpdate.startTime"
                  [ngModelOptions]="{standalone: true}">
              </div>
              <div class="col">
                <label class="sbw_light">Stop Time:</label>
                <input class="form-control" type="datetime-local" [(ngModel)]="assessmentDateUpdate.stopTime"
                  [ngModelOptions]="{standalone: true}">
              </div>
            </div>
            <div class="d-flex justify-content-center flex-wrap gap-1.5">
              <button type="button" class="btn m-0 bg-danger" data-dismiss="modal"
                (click)="submitAssessmentBatch()">Submit</button>
              <button type="button" class="btn m-0" data-dismiss="modal">Close</button>
            </div>
          </div>
        </div>
      </div>
    </div> -->
